import React from 'react';

export const LoadingState: React.FC = () => (
  <div className="data-table-container">
    <div className="loading-state">
      <div className="loading-spinner"></div>
      <p>Loading founders...</p>
    </div>
  </div>
);

export default LoadingState;
